import { useState } from "react";
import {
	Button,
	Box,
	Dialog,
	TextField,
	DialogTitle,
	MenuItem,
	DialogActions,
} from "@mui/material";

const TaskDialog = ({
	t,
	dialogData,
	setDialogData,
	alerts,
	handleTask,
	toggleDialogIsOpen,
	dialogIsOpen,
}) => {
	const [formErrors, setFormErrors] = useState({});
	const handleSave = () => {
		let errors = {};
		setFormErrors({});

		if (dialogData.description === "") {
			errors = { ...errors, description: t("Please provide a description.") };
		}

		if (dialogData.details === "") {
			errors = {
				...errors,
				details: t("Please provide details about this task."),
			};
		}

		if (dialogData.details.length > 600) {
			errors = {...errors, details: t("Please limit details to 600 characters, current length is ") + dialogData.details.length}
		}
		
		if (dialogData.comments.length > 600) {
			errors = {...errors, comments : t("Please limit comments to 600 characters, current length is ") +  dialogData.comments.length}
		}

		if (dialogData.location === "") {
			errors = { ...errors, location: t("Please provide a location.") };
		}

		if (dialogData.system === "") {
			errors = { ...errors, system: t("Please provide a system.") };
		}

		if (dialogData.device === "") {
			errors = { ...errors, device: t("Please provide a device.") };
		}

		if (dialogData.comments === "") {
			errors = {
				...errors,
				comments: "Please provide a comments about this task.",
			};
		}

		if (Object.keys(errors).length === 0) {
			handleTask();
		} else {
			setFormErrors(errors);
		}
	};

	const handleCancel = () => {
		toggleDialogIsOpen();
	};

	const statuses = ["OPEN", "IN_PROGRESS", "CLOSED"];
	return (
		<Dialog
			open={dialogIsOpen}
			onClose={() => toggleDialogIsOpen()}
			fullWidth
			maxWidth={"md"}
		>
			<Box
				sx={{
					paddingLeft: "24px",
					paddingRight: "20px",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<DialogTitle sx={{paddingLeft:0}} color="primary">{t("Task Details")}</DialogTitle>
				<TextField
					select
					id="status"
					label={t("status")}
					variant="standard"
					defaultValue="OPEN"
					onChange={(event) =>
						setDialogData({ ...dialogData, status: event.target.value })
					}
					value={dialogData.status}
				>
					{statuses.map((status) => (
						<MenuItem
							value={status}
							key={status}
						>
							{t(status.replace("_", " "))}
						</MenuItem>
					))}
				</TextField>
				<TextField
					variant="standard"
					label={t("Description")}
					error={formErrors.description ? true : false}
					helperText={formErrors.description}
					value={dialogData.description}
					onChange={(event) =>
						setDialogData({ ...dialogData, description: event.target.value })
					}
				/>
				<TextField
					variant="standard"
					label={t("Location")}
					error={formErrors.location ? true : false}
					helperText={formErrors.location}
					value={dialogData.location}
					onChange={(event) =>
						setDialogData({ ...dialogData, location: event.target.value })
					}
				/>
				<TextField
					variant="standard"
					label={t("System")}
					error={formErrors.system ? true : false}
					helperText={formErrors.description}
					value={dialogData.system}
					onChange={(event) =>
						setDialogData({ ...dialogData, system: event.target.value })
					}
				/>
				<TextField
					variant="standard"
					label={t("Device")}
					error={formErrors.device ? true : false}
					helperText={formErrors.device}
					value={dialogData.device}
					onChange={(event) =>
						setDialogData({ ...dialogData, device: event.target.value })
					}
				/>
				<TextField
					label={t("Alert")}
					variant="standard"
					defaultValue=""
					select
					onChange={(event) =>
						setDialogData({ ...dialogData, linked_alert: event.target.value })
					}
					error={formErrors.linked_alert ? true : false}
					helperText={formErrors.linked_alert}
					value={dialogData.linked_alert}
				>
					{alerts.map((alert) => (
						<MenuItem
							key={alert.name}
							value={alert.url}
						>
							{alert.name}
						</MenuItem>
					))}
				</TextField>
				<TextField
					variant="standard"
					label={t("Details")}
					error={formErrors.details ? true : false}
					helperText={formErrors.details}
					value={dialogData.details}
					multiline
					onChange={(event) =>
						setDialogData({ ...dialogData, details: event.target.value })
					}
				/>
				<TextField
					variant="standard"
					label={t("Comments")}
					error={formErrors.comments ? true : false}
					helperText={formErrors.comments}
					value={dialogData.comments}
					multiline
					onChange={(event) =>
						setDialogData({ ...dialogData, comments: event.target.value })
					}
				/>
				<DialogActions>
					<Button onClick={handleSave}>{t("Save")}</Button>
					<Button onClick={handleCancel}>{t("Cancel")}</Button>
				</DialogActions>
			</Box>
		</Dialog>
	);
};

export default TaskDialog;
